export default {

  // converts an xml node to an json object with all childs and attributes
  node2json(elem) {
//    console.log('elem',elem);
    var node = { localName: elem.localName, nodeName: elem.nodeName, type: elem.nodeType, ns: elem.namespaceURI };
    var attr = {};
    if (elem.attributes) {
      for (var a=0;a<elem.attributes.length;a++) {
        var entry = elem.attributes.item(a);
        // ignore namespace attributes
        if (!entry.nodeName.startsWith('xmlns')) {
          attr[entry.nodeName] = { localName: entry.localName, nodeName: entry.nodeName, value: entry.nodeValue, ns: entry.namespaceURI };
        }
      }
    }
    node.attributes = attr;
    if (elem.childNodes && elem.childNodes.length > 0) {
      var children = [];
      for (var c=0;c<elem.childNodes.length;c++) {
        var child = elem.childNodes[c];
        // only use elements no padding
        if (child && child.nodeType !== 3) {
          children.push(this.node2json(child));
        }
      }
      node.children = children;
    } else if (elem.textContent) {
      node.content = elem.textContent;
    }
    return node;
  },

  // converts an xml document to an json document
  xml2json(doc) {
    var result = { encoding: doc.charset };
    result.root = this.node2json(doc.documentElement);
    return result;
  },

  // convert and append xml node from json data
  json2node(node,root,doc,nsparent,nsmapparent) {
    var elem;

    var ns = nsparent;
    var nsmap = {};
    if (nsmapparent)
      nsmap = JSON.parse(JSON.stringify(nsmapparent)); // copy namespace map

    // create base element
    if (node.type == 1) {
      //console.log('xml json node: ',node,node.attributes.length);

      //console.log('nsmap',ns,nsmap)
      if (node.ns && node.ns !== '') {
        elem = doc.createElementNS(node.ns,node.localName);
      } else {
        elem = doc.createElement(node.localName);
      }

      // check attributes
      if (node.attributes) {
        for (var a in node.attributes) {
          var attr = node.attributes[a];
          if (attr.ns && attr.ns !== '') {
            elem.setAttributeNS(attr.ns, node.attributes[a].localName ,node.attributes[a].value);
          } else {
            elem.setAttribute(node.attributes[a].localName ,node.attributes[a].value);
          }
        }
      }

      // create children if needed
      if (node.children && node.children.length > 0) {
        for (var i in node.children) {
          this.json2node(node.children[i],elem,doc,ns,nsmap);
        }
      }
    // convert cdata content to xml
    } else if (node.type == 4) {
      elem = doc.createCDATASection(node.content);
    } else {
      console.warn('Unknown Node type: ',node);
    }

    // attach to document
    if (!root) {
      doc.appendChild(elem);
    } else {
      root.appendChild(elem);
    }

  },

  // converts an json document to an xml document (structure given like the result from xml2json)
  json2xml(json) {
    var xml = new Document();
    this.json2node(json.root,false,xml);
    return xml;
  },

  // get fist child with node name
  firstchild(children,name) {
    for (var i in children) {
      if (children[i].localName == name) {
        return children[i];
      }
    }
  },

  jsonxmlattr(elem,ns,name) {
    console.log('json attr',elem,ns,name);
    if (!elem.attributes) return false;
    for (var i in elem.attributes) {
      var a = elem.attributes[i];
      console.log('attr',a)
      if (a.localName == name) {
        console.log('attr cand',a.localName,ns,a.ns,a);
        if (!ns) return a;
        if (ns == a.ns) return a;
      }
    }
    return false;
  },

  jsonxmlchild(elem,name) {
    if (!elem.children) return false;
    for (var i in elem.children) {
      var item = elem.children[i];
      if (item.localName == name) {
        return item;
      }
    }
    return false;
  }

}
